<div class="pd40">
    <div fxLayout="row" fxLayoutAlign="space-between" class="mgb30 border-b">
        <div>
            <h6 class="ft500 ft16"> Categorias</h6>
        </div>
    </div>
    <div class="border-t border-l border-r radius3 w-20">
        <div *ngFor="let item of categorias;  let i=index" class="border-b">
            <div fxLayoutAlign="space-between center">
                <p class="centertext mg05 gray-4"> {{i}}</p>
                <p class="centertext mg05"> {{item}}</p>
                <p class="centertext mg05 gray-6"> 7</p>
            </div>

        </div>
    </div>
</div>